import { render, staticRenderFns } from "./page-top.vue?vue&type=template&id=b8fae104"
import script from "./page-top.vue?vue&type=script&lang=js"
export * from "./page-top.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports